import React, { useCallback, useEffect, useMemo, useState } from "react";
// import "./Routes.scss";
import "./ReceiveReturnDetail.scss";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, Checkbox, Divider, Grid, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Constants from "../Common/Constants";
import LabelText from "../Common/LabelText";
import Utils from "../Common/Utils";
import IdentityManager from "../Managers/Identity.manager";
import OMSManager from "../Managers/Oms.manager";
import OrderManager from "../Managers/Orders.Manager";
import { ICustomerDetail } from "../Models/IPickOrder";
import { IButton, INotificationPopupSettings } from "../Models/INotificationPopupSettings";
import { IImageViewerDetail, IImageViewerPopupSettings } from "../Models/IImageViewerPopupSettings";
import allActions from "../Store/Actions/AllActions";
import { ArrowBackIosNewOutlinedIcon, CloseIcon, DoneIcon, ExpandMoreIcon } from "../Subcomponent/Shared/SharedIcons";
import { CustomerDetails } from "../Subcomponent/Shared/CustomerDetails";
import { ImageViewerPopup } from "../Subcomponent/Shared/ImageViewerPopup";
import { NotificationPopup } from "../Subcomponent/Shared/NotificationPopup";

const ReceiveReturnDetail = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(window.location.search);
  const urlOrderNo = urlParams.get("orderno") ?? "";
  const urlShipmentKey = urlParams.get("shipmentkey") ?? "";
  const urlExtnTrackingNo = urlParams.get("ExtnTrackingNo") ?? "";
  const urlStore = urlParams.get("store") ?? "";
  //const detailKey = urlShipmentKey || urlOrderNo;
  const [orderDetail, setOrderDetail] = useState({} as any);
  const [queueRow, setQueueRow] = useState({} as any);
  const [isLoaded, setLoaded] = useState(false);
  const [isOmsDetailLoaded, setOmsDetailLoaded] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [openError, setOpenError] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openReturnConfirm, setOpenReturnConfirm] = useState(false);
  const [imagePopUp, setImagePopUp] = useState(false);
  const [imageData, setImageData] = useState({} as IImageViewerDetail);
  const [selectedLines, setSelectedLines] = useState<Record<string, boolean>>({});
  const [receiveQuantities, setReceiveQuantities] = useState<Record<string, number>>({});

  const showActionLoader = useCallback(() => {
    dispatch(allActions.actionLoaderActions.showLoader());
  }, [dispatch]);

  const hideActionLoader = useCallback(() => {
    dispatch(allActions.actionLoaderActions.hideLoader());
  }, [dispatch]);

  //const getOrderFromRow = useCallback((row: any) => row?._source?.Shipment ?? {}, []);

  const getLinesFromOrder = useCallback((order: any) => {
    const lines = order?.receiveReturnLines ?? order?.ShipmentLines?.ShipmentLine ?? order?.OrderLines?.OrderLine ?? [];
    return Array.isArray(lines) ? lines : [lines];
  }, []);

  const normalizeLines = useCallback((order: any) => {
    const lines = order?.OrderLines?.OrderLine ?? order?.receiveReturnLines ?? order?.ShipmentLines?.ShipmentLine ?? [];
    return Array.isArray(lines) ? lines : [lines];
  }, []);

  const getActiveStoreIds = useCallback(() => {
    const storeId = urlStore || IdentityManager.getMultipleStoresId(props.store);
    if (Array.isArray(storeId)) {
      return storeId.map((store: any) => String(store));
    }
    return storeId ? String(storeId).split(",").map((store: string) => store.trim()).filter(Boolean) : [];
  }, [props.store, urlStore]);

  const isLineForActiveStore = useCallback((line: any, order: any = orderDetail) => {
    const activeStores = getActiveStoreIds();
    if (activeStores.length === 0) {
      return true;
    }
    const receivingNode = line?.ReceivingNode?.toString();
    const orderStore = order?.ShipNode?.toString();
    const lineStore = receivingNode || orderStore;
    return activeStores.includes(lineStore);
  }, [getActiveStoreIds, orderDetail]);

  const lines = useMemo(() => normalizeLines(orderDetail).filter((line: any) => isLineForActiveStore(line, orderDetail)), [isLineForActiveStore, normalizeLines, orderDetail]);

  const getLineKey = (line: any, index: number) => {
    return line?.OrderLineKey ?? `${line?.PrimeLineNo ?? index}-${line?.SubLineNo ?? 1}`;
  };

  const getRemainingQuantity = (line: any) => {
    const remainingQty = Number(line?.RemainingQty ?? 0);
    return Number.isFinite(remainingQty) && remainingQty > 0 ? remainingQty : 0;
  };

  const getTrackingNoFromOrder = useCallback((order: any) => {
    const firstLine = getLinesFromOrder(order)?.[0] ?? {};
    return order?.ExtnTrackingNo || order?.ExtnDisplayTrackingNo || firstLine?.Extn?.ExtnTrackingNo || firstLine?.Extn?.ExtnDisplayTrackingNo || firstLine?.ExtnTrackingNo || firstLine?.ExtnDisplayTrackingNo || "";
  }, [getLinesFromOrder]);

  // const getQueueRowFromSession = useCallback(() => {
  //   if (!detailKey) {
  //     return {};
  //   }

  //   try {
  //     const storedRow = sessionStorage.getItem(`receiveReturnDetail:${detailKey}`);
  //     return storedRow ? JSON.parse(storedRow) : {};
  //   }
  //   catch (error) {
  //     console.log(error);
  //     return {};
  //   }
  // }, [detailKey]);

  // const findQueueRow = useCallback(async () => {
  //   const stateRow = (location.state as any)?.row;
  //   if (stateRow?._source?.Shipment) {
  //     return stateRow;
  //   }

  //   const storedRow = getQueueRowFromSession();
  //   if (storedRow?._source?.Shipment) {
  //     return storedRow;
  //   }

  //   const storeId = urlStore || IdentityManager.getMultipleStoresId(props.store);
  //   if (!storeId || (!urlOrderNo && !urlShipmentKey)) {
  //     return {};
  //   }

  //   const findMatches = (rows: any[]) => {
  //     return rows.filter((row: any) => {
  //       const order = getOrderFromRow(row);
  //       return urlShipmentKey ? order?.OrderHeaderKey === urlShipmentKey : order?.OrderNo === urlOrderNo;
  //     });
  //   };

  //   const detailResponse: any = await OrderManager.orderById({ id: urlShipmentKey, orderno: urlOrderNo });
  //   const detailMatches = findMatches(detailResponse?.data?.hits?.hits ?? []);
  //   if (detailMatches.length === 1 && detailMatches[0]?._source?.Shipment) {
  //     return detailMatches[0];
  //   }

  //   if (detailMatches.length > 1) {
  //     return {};
  //   }

  //   const resultResponse: any = await OrderManager.getReceiveReturns(storeId, { from: 0, size: 1000 });
  //   const matches = findMatches(resultResponse?.data?.hits?.hits ?? []);
  //   return matches.length === 1 ? matches[0] : {};
  // }, [getOrderFromRow, getQueueRowFromSession, location.state, props.store, urlOrderNo, urlShipmentKey, urlStore]);

  // const buildDetailRequest = useCallback((row: any) => {
  //   const order = getOrderFromRow(row);
  //   const trackingNo = getTrackingNoFromOrder(order);

  //   return {
  //     orderNo: order?.OrderNo,
  //     orderHeaderKey: order?.OrderHeaderKey,
  //     documentType: order?.DocumentType ?? "0003",
  //     enterpriseCode: order?.EnterpriseCode ?? "GC",
  //     trackingNo,
  //   };
  // }, [getOrderFromRow, getTrackingNoFromOrder]);

  const getLineTracking = (line: any) => {
    return line?.Extn?.ExtnDisplayTrackingNo ||
      line?.ExtnDisplayTrackingNo ||
      orderDetail?.ExtnDisplayTrackingNo ||
      line?.Extn?.ExtnTrackingNo ||
      line?.ExtnTrackingNo ||
      getTrackingNoFromOrder(orderDetail) ||
      "-";
  };

  const getLineExtensionTracking = (line: any) => {
    return line?.Extn?.ExtnTrackingNo ||
      line?.ExtnTrackingNo ||
      orderDetail?.ExtnTrackingNo ||
      getTrackingNoFromOrder(orderDetail) ||
      "-";
  };

  const getStoreDisplay = (line: any) => {
    return line?.ReceivingNode || orderDetail?.ShipNode || "-";
  };

  const getImageUrl = (line: any) => {
    return line?.ItemDetails?.PrimaryInformation?.ImageUrl || line?.ImageUrl || line?.Item?.ImageUrl || line?.Item?.imageUrl || "";
  };

  const getLineItem = (line: any) => {
    return {
      ...(line?.Item ?? {}),
      ItemID: line?.Item?.ItemID ?? line?.ItemID,
      ItemDesc: line?.Item?.ItemDesc ?? line?.ItemDesc,
      UnitOfMeasure: line?.Item?.UnitOfMeasure ?? line?.UnitOfMeasure,
      ProductClass: line?.Item?.ProductClass ?? line?.ProductClass,
      ImageUrl: line?.Item?.ImageUrl ?? getImageUrl(line),
    };
  };

  const getCustomerDetails = (order: any): ICustomerDetail => {
    const customerInfo = order?.CustomerInfo ?? {};
    const shipFrom = order?.PersonInfoShipFrom ?? {};
    const customerSource = customerInfo?.FirstName || customerInfo?.LastName ? customerInfo : shipFrom;
    const customerDetail = OMSManager.getCustomerDetails(customerSource ?? {});

    return {
      ...customerDetail,
      email: customerDetail.email || order?.CustomerEMailID || customerInfo?.CustomerEMailID || shipFrom?.CustomerEMailID || "",
      phone: customerDetail.phone || order?.CustomerPhoneNo || customerInfo?.DayPhone || customerInfo?.MobilePhone || shipFrom?.DayPhone || shipFrom?.MobilePhone || "",
    };
  };

  const openImageViewer = (line: any) => {
    const item = getLineItem(line);
    setImageData({
      imageURL: getImageUrl(line),
      itemDesc: item.ItemDesc,
      itemID: item.ItemID,
      skuID: item.ItemID,
      price: 0,
      qty: Number(line?.RemainingQty ?? line?.Quantity ?? 0),
    });
    setImagePopUp(true);
  };

  const enrichDetailOrderLines = useCallback((detailOrder: any, queueOrder: any) => {
    const queueLines = getLinesFromOrder(queueOrder);
    const detailLines = normalizeLines(detailOrder);
    const enrichedLines = detailLines.map((line: any) => {
      const item = getLineItem(line);
      const queueLine = queueLines.find((queueLineItem: any) => {
        const queueItem = getLineItem(queueLineItem);
        return (line?.OrderLineKey && queueLineItem?.OrderLineKey === line.OrderLineKey) ||
          (item?.ItemID && queueItem?.ItemID === item.ItemID) ||
          (line?.PrimeLineNo && queueLineItem?.PrimeLineNo === line.PrimeLineNo && line?.SubLineNo && queueLineItem?.SubLineNo === line.SubLineNo);
      });

      if (!queueLine) {
        return null;
      }

      const queueItem = getLineItem(queueLine);
      return {
        ...queueLine,
        ...line,
        ImageUrl: getImageUrl(line) || getImageUrl(queueLine),
        Item: {
          ...queueItem,
          ...item,
          ImageUrl: item?.ImageUrl || getImageUrl(line) || queueItem?.ImageUrl,
        },
        Extn: {
          ...(queueLine?.Extn ?? {}),
          ...(line?.Extn ?? {}),
          ExtnTrackingNo: line?.Extn?.ExtnTrackingNo || line?.ExtnTrackingNo || queueLine?.Extn?.ExtnTrackingNo || queueLine?.ExtnTrackingNo,
          ExtnDisplayTrackingNo: line?.Extn?.ExtnDisplayTrackingNo || line?.ExtnDisplayTrackingNo || queueLine?.Extn?.ExtnDisplayTrackingNo || queueLine?.ExtnDisplayTrackingNo,
        },
      };
    }).filter(Boolean);

    return {
      ...detailOrder,
      OrderLines: {
        ...(detailOrder?.OrderLines ?? {}),
        OrderLine: enrichedLines,
      },
    };
  }, [getLinesFromOrder, normalizeLines]);

  const mergeElasticCustomerDetails = useCallback((detailOrder: any) => { 
    setOrderDetail((currentOrderDetail: any) => ({
        ...currentOrderDetail,
        CustomerInfo: detailOrder?.CustomerInfo ?? currentOrderDetail?.CustomerInfo,
        PersonInfoShipFrom: detailOrder?.PersonInfoShipFrom ?? currentOrderDetail?.PersonInfoShipFrom,
        CustomerEMailID: detailOrder?.CustomerEMailID ?? currentOrderDetail?.CustomerEMailID,
        CustomerPhoneNo: detailOrder?.CustomerPhoneNo ?? currentOrderDetail?.CustomerPhoneNo,
      }));    
  }, []);

  const closeImageViewer = () => {
    setImagePopUp(false);
    setImageData({} as IImageViewerDetail);
  };

  const imageViewerSettings: IImageViewerPopupSettings = {
    open: imagePopUp,
    imageDetail: imageData,
    close: closeImageViewer,
  };

  const loadOrderDetails = async () => {    
    setOmsDetailLoaded(false);
    showActionLoader();
      if (!urlOrderNo || !urlShipmentKey || !urlStore || !urlExtnTrackingNo) {
        setErrorMsg("Missing return order details. Please open this record from Receive Returns.");
        setOpenError(true);
        setLoaded(true);
        hideActionLoader();
        return;
      }
      // get order from elastic 
      var elasticRecord: any = await OrderManager.orderHeaderAndTrackingNo({ id: urlShipmentKey, orderno: urlOrderNo, urlExtnTrackingNo: urlExtnTrackingNo });
      const elasticShipment = elasticRecord?.data?.hits?.hits?.[0]?._source?.Shipment;
      if (!elasticShipment) {
        setOrderDetail({});
        setOmsDetailLoaded(false);
        setErrorMsg("Something went wrong please contact the IT Help Desk for assistance");
        setOpenError(true);
        setLoaded(true);
        hideActionLoader();
        return;
      }
      OMSManager.GCGetUsedReturnOrderDetailsToMSFA(elasticShipment.OrderNo, elasticShipment.OrderHeaderKey, elasticShipment.DocumentType, elasticShipment.EnterpriseCode, elasticShipment.ExtnTrackingNo).then((result: any) => {
      const omsOrder = result?.data?.Order ?? result?.data;
      if (result?.success && omsOrder?.OrderLines) {
        const detailOrder = enrichDetailOrderLines({
          ...elasticShipment,
          ...omsOrder,
          CustomerInfo: elasticShipment?.CustomerInfo,
          PersonInfoShipFrom: elasticShipment?.PersonInfoShipFrom,
          CustomerEMailID: elasticShipment?.CustomerEMailID,
          CustomerPhoneNo: elasticShipment?.CustomerPhoneNo,
          ShipNode: omsOrder?.ShipNode ?? omsOrder?.StoreID ?? elasticShipment?.ShipNode,
          OrderLines: omsOrder?.OrderLines,
          receiveReturnLines: omsOrder?.receiveReturnLines ?? elasticShipment?.receiveReturnLines,
        }, elasticShipment);
        setOrderDetail(detailOrder);
        mergeElasticCustomerDetails(detailOrder);
        setOmsDetailLoaded(true);
      }
      else {
        setOrderDetail({});
        mergeElasticCustomerDetails({});
        setOmsDetailLoaded(false);
        setErrorMsg(result?.msg || "Something went wrong please contact the IT Help Desk for assistance");
        setOpenError(true);
      }
      setLoaded(true);
      hideActionLoader();
      }).catch((error: any) => {
        console.log(error);
        setOrderDetail({});
        setOmsDetailLoaded(false);
        setErrorMsg("Could not load OMS details. Showing queue details for this return.");
        setOpenError(true);
        setLoaded(true);
        hideActionLoader();
      });   
  };

  const closeErrorPopup = () => {
    setOpenError(false);
  };

  const closeSuccessPopup = () => {
    setOpenSuccess(false);
    navigate("/ReceiveReturns");
  };

  const openReturnConfirmPopup = () => {
    setOpenReturnConfirm(true);
  };

  const closeReturnConfirmPopup = () => {
    setOpenReturnConfirm(false);
  };

  const confirmReturn = () => {
    setOpenReturnConfirm(false);
    markReceived();
  };

  const getReturnableLines = () => {
    return lines.reduce((returnableLines: any[], line: any, index: number) => {
      const remainingQty = getRemainingQuantity(line);
      if (remainingQty > 0) {
        returnableLines.push({ line, index, lineKey: getLineKey(line, index) });
      }
      return returnableLines;
    }, []);
  };

  const isReturnDisabled = () => {
    const hasSelectedLine = getReturnableLines().some(({ lineKey }: any) =>
      selectedLines[lineKey] && Number(receiveQuantities[lineKey] ?? 0) > 0
    );
    return !Utils.disableUserAction(props.store) || !isOmsDetailLoaded || !hasSelectedLine;
  };

  const getReceiveQuantityForLine = (line: any, index: number) => {
    return receiveQuantities[getLineKey(line, index)] ?? getRemainingQuantity(line);
  };

  const handleLineSelection = (line: any, index: number, checked: boolean) => {
    const lineKey = getLineKey(line, index);
    if (getRemainingQuantity(line) <= 0) {
      return;
    }

    setSelectedLines((current) => ({ ...current, [lineKey]: checked }));
    if (checked && Number(receiveQuantities[lineKey] ?? 0) <= 0) {
      setReceiveQuantities((current) => ({ ...current, [lineKey]: getRemainingQuantity(line) }));
    }
  };

  const handleReceiveQuantityChange = (line: any, index: number, value: string) => {
    const lineKey = getLineKey(line, index);
    const remainingQty = getRemainingQuantity(line);
    const parsedQty = Number(value);
    const quantity = Number.isFinite(parsedQty) ? Math.min(remainingQty, Math.max(1, parsedQty)) : 1;

    setReceiveQuantities((current) => ({ ...current, [lineKey]: quantity }));
  };

  const logReceiveReturnHistory = async (linesToReturn: any[]) => {
    const totalQty = linesToReturn.reduce((qty: number, line: any) => qty + Number(line?.ReceiveQtyToSubmit ?? 0), 0);
    const trackingNumbers = Array.from(new Set(linesToReturn.map((line: any) => getLineTracking(line)).filter(Boolean)));
    const receivedAt = Date.now();
    const transactionDate = new Date(receivedAt).toISOString();
    const receiveReturnCreatedDate = orderDetail?.OrderDate ?? "";
    const createdAt = Date.parse(receiveReturnCreatedDate);
    const receiveReturnAgeSeconds = Number.isNaN(createdAt)
      ? ""
      : String(Math.max(0, Math.floor((receivedAt - createdAt) / 1000)));
    const lineHistory = linesToReturn.map((line: any) => {
      const linePriceInfo = line?.LinePriceInfo ?? {};
      return {
        orderLineKey: line?.OrderLineKey,
        primeLineNo: line?.PrimeLineNo,
        subLineNo: line?.SubLineNo,
        quantityReceived: String(line?.ReceiveQtyToSubmit ?? "0"),
        remainingQty: line?.RemainingQty,
        receivingNode: line?.ReceivingNode,
        shipNode: line?.ShipNode ?? line?.ReceivingNode,
        itemId: getLineItem(line)?.ItemID,
        itemDesc: getLineItem(line)?.ItemDesc,
        trackingNo: getLineTracking(line),
        RetailPrice: linePriceInfo?.RetailPrice ?? line?.RetailPrice ?? "",
        ListPrice: linePriceInfo?.ListPrice ?? line?.ListPrice ?? "",
        UnitPrice: linePriceInfo?.UnitPrice ?? line?.UnitPrice ?? "",
        LineTotal: linePriceInfo?.LineTotal ?? line?.LineTotal ?? "",
      };
    });

    await OrderManager.saveOrderHistory({
      orderNo: orderDetail?.OrderNo,
      orderno: orderDetail?.OrderNo,
      shipmentKey: orderDetail?.OrderHeaderKey,
      orderHeaderKey: orderDetail?.OrderHeaderKey,
      logType: "history",
      transactionType: Constants.OrderHistoryTypes.Receive_Return,
      message: `Received return qty ${totalQty} at Store ${linesToReturn?.[0]?.ReceivingNode || orderDetail?.ShipNode || ""}`,
      transactionDate,
      receiveReturnCreatedDate,
      receiveReturnAgeSeconds,
      receiveReturnStore: linesToReturn?.[0]?.ReceivingNode || orderDetail?.ShipNode || "",
      receiveReturnQty: String(totalQty),
      receiveReturnTrackingNumbers: trackingNumbers.join(","),
      items: lineHistory,
    });
    dispatch(allActions.orderHistoryActions.forceHistoryLoad());
  };

  const markReceived = () => {
    const returnableLines = getReturnableLines();
    if (!isOmsDetailLoaded) {
      setErrorMsg("Could not load OMS details for this return.");
      setOpenError(true);
      return;
    }

    if (returnableLines.length === 0) {
      setErrorMsg("No returnable lines available.");
      setOpenError(true);
      return;
    }

    const linesToReturn = returnableLines.filter((returnableLine: any) => {
      return selectedLines[returnableLine.lineKey] && Number(receiveQuantities[returnableLine.lineKey] ?? 0) > 0;
    }).map((returnableLine: any) => {
      return {
        ...returnableLine.line,
        ReceiveQtyToSubmit: getReceiveQuantityForLine(returnableLine.line, returnableLine.index),
      };
    });

    if (linesToReturn.length === 0) {
      setErrorMsg("Select at least one item with a quantity greater than 0.");
      setOpenError(true);
      return;
    }

    if (linesToReturn.some((line: any) => !isLineForActiveStore(line, orderDetail))) {
      setErrorMsg("Selected line does not belong to the active store.");
      setOpenError(true);
      return;
    }

    if (linesToReturn.some((line: any) => Number(line.ReceiveQtyToSubmit) <= 0)) {
      setErrorMsg("Enter a receive quantity for each selected line.");
      setOpenError(true);
      return;
    }

    showActionLoader();
    OMSManager.GCReceiveUsedStoreReturns(orderDetail, linesToReturn).then(async (result: any) => {
      if (result?.success) {
        try {
          await logReceiveReturnHistory(linesToReturn);
        }
        catch (error) {
          console.log(error);
        }
        hideActionLoader();
        setSuccessMsg("Return received successfully.");
        setOpenSuccess(true);
      }
      else {
        hideActionLoader();
        setErrorMsg(result?.msg || "Something went wrong please contact the IT Help Desk for assistance");
        setOpenError(true);
      }
    }).catch((error: any) => {
      console.log(error);
      hideActionLoader();
      setErrorMsg("Something went wrong please contact the IT Help Desk for assistance");
      setOpenError(true);
    });
  };

  const errorPopupCloseButtons: IButton[] = [{
    text: "Close",
    icon: <CloseIcon />,
    action: closeErrorPopup,
    color: Constants.Colors.red,
  }];

  const errorPopup: INotificationPopupSettings = {
    open: openError,
    type: Constants.NotificationPopupType.Error,
    title: "Error",
    msg: errorMsg,
    draggable: false,
    handleClose: closeErrorPopup,
    actions: errorPopupCloseButtons,
  };

  const successPopupButtons: IButton[] = [{
    text: "Close",
    icon: <CloseIcon />,
    action: closeSuccessPopup,
    color: Constants.Colors.red,
  }];

  const successPopup: INotificationPopupSettings = {
    open: openSuccess,
    type: Constants.NotificationPopupType.Success,
    title: "Success",
    msg: successMsg,
    draggable: false,
    handleClose: closeSuccessPopup,
    actions: successPopupButtons,
  };

  const returnConfirmPopupButtons: IButton[] = [
    {
      text: "Return",
      icon: <DoneIcon />,
      action: confirmReturn,
      color: Constants.Colors.yellow,
    },
    {
      text: "Cancel",
      icon: <CloseIcon />,
      action: closeReturnConfirmPopup,
      color: Constants.Colors.red,
    },
  ];

  const returnConfirmPopup: INotificationPopupSettings = {
    open: openReturnConfirm,
    type: Constants.NotificationPopupType.Warning,
    title: LabelText.NotificationPopupHeaders.Warning,
    msg: LabelText.ReceiveReturns.MarkReturnWarning,
    draggable: false,
    handleClose: closeReturnConfirmPopup,
    actions: returnConfirmPopupButtons,
  };

  const renderLine = (line: any, index: number) => {
    const item = getLineItem(line);
    const imageUrl = getImageUrl(line);
    const remainingQty = getRemainingQuantity(line);
    const lineKey = getLineKey(line, index);
    const canReceive = remainingQty > 0;
    const isSelected = canReceive && Boolean(selectedLines[lineKey]);
    const rawLineStatus = line?.MaxLineStatusDesc || line?.StatusDesc || "Created";
    const normalizedLineStatus = String(rawLineStatus).toUpperCase().replace(/ /g, "_");
    const lineStatusCode = String(line?.MaxLineStatus ?? line?.Status ?? orderDetail?.Status ?? "");
    const isClosedLine = lineStatusCode === Constants.ReceiveReturnsStatus.ReturnClosedCode || normalizedLineStatus === Constants.ReceiveReturnsStatus.ReturnClosed;
    const isCreatedLine = lineStatusCode === Constants.ReceiveReturnsStatus.ReturnWithCarrierCode || normalizedLineStatus === "WITH_CARRIER" || normalizedLineStatus === Constants.ReceiveReturnsStatus.ReturnWithCarrier;
    const lineStatus = isClosedLine ? "Return Closed" : isCreatedLine ? "Created" : rawLineStatus;

    return (
      <Box key={line?.OrderLineKey ?? index}>
        <Grid container spacing={1} display={"flex"} style={{ marginTop: Utils.isMobile ? "8px" : "12px" }} className="justifyBetween productHeader">
          <div style={{ width: "100%" }}>
            <Grid item container alignItems="center" wrap="nowrap" style={{ columnGap: Utils.isMobile ? 10 : 18 }}>
              <Grid item display={"flex"} alignItems="center" style={{ columnGap: Utils.isMobile ? 12 : 18, flexWrap: "wrap" }}>
                <Checkbox
                  checked={isSelected}
                  disabled={!canReceive}
                  onChange={(event) => handleLineSelection(line, index, event.target.checked)}
                  inputProps={{ "aria-label": `Select ${item?.ItemDesc ?? "return item"}` }}
                  size="small"
                />
                {canReceive &&
                  <Box display="flex" alignItems="center" sx={{ columnGap: "8px" }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, whiteSpace: "nowrap" }} color="text.secondary">Receive Qty</Typography>
                    <TextField
                      type="number"
                      size="small"
                      value={getReceiveQuantityForLine(line, index)}
                      onChange={(event) => handleReceiveQuantityChange(line, index, event.target.value)}
                      inputProps={{ min: 1, max: remainingQty, step: "any", "aria-label": "Receive Qty" }}
                      sx={{
                        width: 76,
                        minWidth: 76,
                        "& .MuiOutlinedInput-root": {
                          height: 34,
                          backgroundColor: "white",
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "6px 8px !important",
                          fontSize: 14,
                        },
                      }}
                    />
                  </Box>}
                <Box display="flex" alignItems="center" sx={{ columnGap: "5px" }}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary">Remaining</Typography>
                  <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{remainingQty}</Typography>
                </Box>
                <Box display="flex" alignItems="center" sx={{ columnGap: "5px" }}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary">Status</Typography>
                  <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{lineStatus}</Typography>
                </Box>
              </Grid>
            </Grid>
          </div>
        </Grid>
        {Utils.isMobile ?
          <React.Fragment>
            <Grid spacing={2} container style={{ margin: "0px" }} sx={{ flexGrow: 1 }}>
              <Grid item xs={4} sm={4} style={{ padding: "8px" }}>
                {imageUrl ?
                  <img style={{ height: "100px", cursor: "zoom-in" }} alt="" src={Utils.convertToHttps(imageUrl)} onClick={() => openImageViewer(line)} /> :
                  <div style={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #ddd", borderRadius: 4 }}>
                    <Typography style={{ fontSize: 12, color: "#777" }}>No Image</Typography>
                  </div>}
              </Grid>
              <Grid item xs={6} sm={6} style={{ padding: "8px", textAlign: "left" }}>
                <Tooltip title={item?.ItemDesc ?? ""}>
                  <Typography style={{ fontSize: "16px", fontWeight: 400 }}>{item?.ItemDesc ?? "-"}</Typography>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid container spacing={1} style={{ paddingLeft: "5px", paddingRight: "5px" }}>
              <Grid item xs={6} sm={6} style={{ textAlign: "left" }}>
                <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Item #</Typography>
                <Typography sx={{ fontSize: 13, wordBreak: "break-all" }} gutterBottom><b>{item?.ItemID || "-"}</b></Typography>
              </Grid>
              <Grid item xs={6} sm={6} style={{ textAlign: "left" }}>
                <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Store</Typography>
                <Typography sx={{ fontSize: 13 }} gutterBottom><b>{getStoreDisplay(line)}</b></Typography>
              </Grid>
            </Grid>
            <Grid container spacing={1} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: "2px" }}>
              <Grid item xs={12} sm={12} style={{ textAlign: "left" }}>
                <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Tracking #</Typography>
                <Typography sx={{ fontSize: 13, wordBreak: "break-all" }} gutterBottom><b>{getLineExtensionTracking(line)}</b></Typography>
              </Grid>
            </Grid>
          </React.Fragment> :
          <Grid container spacing={1} style={{ margin: "0px" }} sx={{ flexGrow: 1 }}>
            <Grid item xs={4} sm={3} md={2} style={{ padding: "8px", display: "flex", justifyContent: "center" }}>
              <div className={imageUrl ? "image-zoom" : ""} onClick={() => imageUrl ? openImageViewer(line) : null} style={{ width: "100%", minHeight: 118, display: "flex", alignItems: "center", justifyContent: "center", border: imageUrl ? "" : "1px solid #ddd", borderRadius: 4 }}>
                {imageUrl ?
                  <img style={{ height: "auto", maxHeight: 120, cursor: "zoom-in" }} alt="" src={Utils.convertToHttps(imageUrl)} /> :
                  <Typography style={{ fontSize: 12, color: "#777" }}>No Image</Typography>}
              </div>
            </Grid>
            <Grid item xs={8} sm={9} md={10} style={{ padding: "8px", textAlign: "left" }}>
              <Tooltip title={item?.ItemDesc ?? ""}>
                <Typography style={{ fontSize: "16px", fontWeight: 400 }}>{item?.ItemDesc ?? "-"}</Typography>
              </Tooltip>
              <Grid container spacing={1} style={{ marginTop: 12 }}>
                <Grid item xs={12} sm={4} style={{ textAlign: "left" }}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Item #</Typography>
                  <Typography sx={{ fontSize: 13 }} gutterBottom><b>{item?.ItemID || "-"}</b></Typography>
                </Grid>
                <Grid item xs={12} sm={4} style={{ textAlign: "left" }}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Tracking #</Typography>
                  <Typography sx={{ fontSize: 13, wordBreak: "break-all" }} gutterBottom><b>{getLineExtensionTracking(line)}</b></Typography>
                </Grid>
                <Grid item xs={12} sm={4} style={{ textAlign: "left" }}>
                  <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>Store</Typography>
                  <Typography sx={{ fontSize: 13 }} gutterBottom><b>{getStoreDisplay(line)}</b></Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
        <Divider></Divider>
      </Box>
    );
  };

  const renderOrderDetails = () => {
    const firstLine = lines?.[0] ?? {};
    const trackingNo = getLineTracking(firstLine);
    const receivingNode = firstLine?.ReceivingNode || orderDetail?.ShipNode || "-";

    return (
      <Card className="dCard" style={{ margin: Utils.isMobile ? 4 : 16 }}>
        <CardContent className={Utils.isMobile ? "" : "dCardContent"}>
          <Typography className="card-heading">{Constants.ReceiveReturnsLabels.ReturnOrderDetails}</Typography>
          <Divider />
          <Grid container spacing={1} style={{ paddingTop: 10, paddingBottom: 4 }}>
            <Grid item xs={12} sm={6} style={{ textAlign: "left" }}>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography sx={{ fontSize: 13 }}>Tracking No :</Typography>
                </Grid>
                <Grid item xs>
                  <Typography sx={{ fontSize: 13, wordBreak: "break-all" }}>
                    <b>{trackingNo}</b>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} style={{ textAlign: "left" }}>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography sx={{ fontSize: 13 }}>Receiving Node :</Typography>
                </Grid>
                <Grid item xs>
                  <Typography sx={{ fontSize: 13 }}>
                    <b>{receivingNode}</b>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const renderCustomerDetails = () => {
    const customerDetail = getCustomerDetails(orderDetail);

    if (Utils.isMobile) {
      return (
        <Accordion style={{ margin: 5, padding: 10, borderRadius: 16, boxShadow: "0px 1px 1px 1px rgb(0 0 0 / 20%), 0px 1px 1px 1px rgb(0 0 0 / 14%), 0px 1px 1px 2px rgb(0 0 0 / 12%)" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="receive-return-customer-details-content"
            id="receive-return-customer-details-header"
            style={{ color: Constants.Colors.darkGrey, height: 80 }}
          >
            <div className="topHeading">
              <div className="gridHeading" style={{ display: "flex" }}>
                <Typography>Customer Details</Typography>
              </div>
            </div>
          </AccordionSummary>
          <Divider />
          <AccordionDetails style={{ display: "block", padding: 0, overflowY: "scroll" }}>
            <CustomerDetails customerDetail={customerDetail}></CustomerDetails>
          </AccordionDetails>
        </Accordion>
      );
    }

    return (
      <Card className="dCard" style={{ margin: Utils.isMobile ? 4 : 16 }}>
        <CardContent className={Utils.isMobile ? "" : "dCardContent"}>
          <Typography className="card-heading"> Customer Details</Typography>
          <Divider />
          <CustomerDetails customerDetail={customerDetail}></CustomerDetails>
        </CardContent>
      </Card>
    );
  };

  useEffect(() => {
    loadOrderDetails();// convert it to async
  }, []);

  return (
    <div className="receiveReturnDetailPage">
      <NotificationPopup {...errorPopup} />
      <NotificationPopup {...successPopup} />
      <NotificationPopup {...returnConfirmPopup} />
      <ImageViewerPopup {...imageViewerSettings} />
      <Box style={{ margin: Utils.isMobile ? "6px" : "20px" }}>
        {Utils.isMobile ?
          <Paper style={{ marginTop: 2, paddingTop: 1, paddingBottom: 1, background: "#F9F9F9" }}>
            <Grid container style={{ paddingTop: "20px", paddingBottom: "20px" }}>
              <Grid item xs={12} sm={12} className="textLeft">
                <Grid container style={{ paddingLeft: "12px" }}>
                  <Grid item xs={3}>
                    <Button onClick={() => navigate("/ReceiveReturns")} className="back-button" variant="contained" startIcon={<ArrowBackIosNewOutlinedIcon />}>Back</Button>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography className="medium-heading">{Constants.ReceiveReturnsLabels.ReturnOrderNumber}</Typography>
                    <Typography className="large-heading" style={{ wordBreak: "break-all" }}>{orderDetail?.OrderNo}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={0} style={{ marginBottom: "10px", padding: "10px" }}>
              <Grid item xs={12} sm={12}>
                <Button
                  onClick={() => openReturnConfirmPopup()}
                  style={{ width: "100%" }}
                  variant="contained"
                  disabled={isReturnDisabled()}
                  className={isReturnDisabled() ? "header-button disabled" : "header-button red"}
                >
                  Receive Returns
                </Button>
              </Grid>
            </Grid>
          </Paper> :
          <Grid container spacing={2} display={"flex"} alignItems="center">
            <Grid item xs={5} sm={5} className="textLeft">
              <Grid container display={"flex"}>
                <Grid item>
                  <Button onClick={() => navigate("/ReceiveReturns")} className="back-button" variant="contained" startIcon={<ArrowBackIosNewOutlinedIcon />}>Back</Button>
                </Grid>
                <Grid item style={{ marginLeft: "30px" }}>
                  <Typography className="medium-heading">{Constants.ReceiveReturnsLabels.ReturnOrderNumber}</Typography>
                  <Typography className="large-heading">{orderDetail?.OrderNo}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={7} sm={7} className="textRight" style={{ paddingRight: "34px" }}>
              <Button
                sx={{
                  width: "190px !important",
                  minWidth: "190px !important",
                  height: "38px !important",
                  fontSize: "18px !important",
                }}
                disabled={isReturnDisabled()}
                variant="contained"
                className={isReturnDisabled() ? "header-button disabled" : "header-button underline"}
                onClick={() => openReturnConfirmPopup()}
              >
                Receive Returns
              </Button>
            </Grid>
          </Grid>
        }

        <div style={{ marginTop: "26px" }}>
          <Grid container spacing={Utils.isMobile ? 0 : 2} display={"flex"} style={{ padding: "0px" }}>
            <Grid item xs={12} sm={12} style={{ paddingTop: "0px", paddingRight: "4px", paddingLeft: "0px" }} className="textLeft">
              {renderOrderDetails()}
              <Card className="dCard" style={{ margin: Utils.isMobile ? 4 : 16 }}>
                <CardContent className={Utils.isMobile ? "" : "dCardContent"}>
                  <Typography className="card-heading">{Constants.ReceiveReturnsLabels.ReturnOrderLines}</Typography>
                  <Divider />
                  <div style={{ padding: Utils.isMobile ? "5px" : "10px" }}>
                    {isLoaded && lines.length > 0 ? lines.map(renderLine) : <Paper style={{ padding: 16, marginTop: 12 }}><Typography>No line items to display</Typography></Paper>}
                  </div>
                </CardContent>
              </Card>
              {renderCustomerDetails()}
            </Grid>
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default ReceiveReturnDetail;
